/**
 * get the history state as an object.
 * @return {Object} The history state object or an empty object.
 */
export function getState(){
	return window.history.state || {};
}

/**
 * wrapper around history.pushState.
 * @param {Object} state - The new state value.
 * @param {string} [url] - The new url.
 */
export function pushState(state, url){
	window.history.pushState(state, document.title, url);
}

/**
 * wrapper around history.replaceState.
 * @param {Object} state - The new state value.
 * @param {string} [url] - The new url.
 */
export function replaceState(state, url){
	window.history.replaceState(state, document.title, url);
}

/**
 * When state has not been set calls replaceState, when state has been set 
 * called pushState.
 * @param {Object} state - The new state value.
 * @param {string} [url] - The new url.
 */
export function setState(state, url){
	if (history.state === null){
		replaceState(state, url);
		return;
	}
	pushState(state, url);
}